import { render, staticRenderFns } from "./DataPerm.vue?vue&type=template&id=7dd192e8&"
import script from "./DataPerm.vue?vue&type=script&lang=js&"
export * from "./DataPerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports